import { createFileRoute } from "@tanstack/react-router";

import { HeroSubtitle } from "@/components/marketing/BrandLockup";
import FaqSection from "@/components/marketing/FaqSection";
import HowItWorks from "@/components/marketing/HowItWorks";
import { marketingHead } from "@/components/marketing/marketingHead";
import ProductHero from "@/components/marketing/ProductHero";
import { ENHANCED_ALBUMS_LIVE } from "@/components/marketing/products";
import RelatedProducts from "@/components/marketing/RelatedProducts";
import SuperAlbumsTeaser from "@/components/marketing/super-singles/SuperAlbumsTeaser";
import SuperFanSection from "@/components/marketing/super-singles/SuperFanSection";
import SuperHeroShot from "@/components/marketing/super-singles/SuperHeroShot";
import SuperShowcase from "@/components/marketing/super-singles/SuperShowcase";
import SuperSingleLockup from "@/components/marketing/super-singles/SuperSingleLockup";
import Footer from "@/components/nav/Footer";

const LEDE =
  "Turn one single into a richer fan product by including the clean version, instrumental, acapella, video, or other exclusive content, without the extra work.";

export const Route = createFileRoute("/super-single")({
  component: SuperSinglesPage,
  head: () =>
    marketingHead({
      title: "Super Singles | Sell More Than a Song | Lutely",
      description: LEDE,
      path: "/super-single",
    }),
});

const FAQ = [
  {
    question: "What is a Super Single?",
    answer:
      "A Super Single is a single sold with additional downloadable assets and exclusive content.",
  },
  {
    question: "Which assets can I include?",
    answer:
      "You can include assets such as the clean version, instrumental, acapella, video, and other approved files.",
  },
  {
    question: "Does every single need to be a Super Single?",
    answer:
      "No. Artists can sell a standard single or choose to add the extra assets.",
  },
  {
    question: "Can fans stream the main song?",
    answer:
      "Yes. Buyers can stream the release and download the assets included by the artist.",
  },
];

function SuperSinglesPage() {
  return (
    <main className="flex flex-col bg-white">
      <ProductHero
        title={
          <>
            <SuperSingleLockup />
            <br />
            <HeroSubtitle>Sell more than a song.</HeroSubtitle>
          </>
        }
        lede={LEDE}
        cta="Create a Super Single"
        proof={["Bundle Lutely-extracted assets", "Give fans more to own"]}
        stage={<SuperHeroShot />}
      />
      <HowItWorks
        title="Make every single feel bigger."
        intro="Use the assets Lutely extracts from your track to offer fans a deeper, more valuable release."
        steps={[
          {
            title: "Upload your song",
            body: "Lutely automatically extracts the instrumental and acapella and creates a clean version when your song is explicit.",
          },
          {
            title: "Build your Super Single",
            body: "Create a release and choose which versions and exclusive content to include.",
          },
          {
            title: "Publish",
            body: "Set your price and give fans a complete package they can stream, download, and own.",
          },
        ]}
      />
      <SuperShowcase />
      <SuperFanSection />
      <FaqSection items={FAQ} title="FAQs" kicker={false} />
      {ENHANCED_ALBUMS_LIVE && <SuperAlbumsTeaser />}
      <RelatedProducts current="super" />
      <Footer />
    </main>
  );
}
